import { atom } from "recoil";

export const pooolMapState = atom<any>({
  key: "pooolMapState",
  default: new Map(),
  dangerouslyAllowMutability: true,
});

export const pooolAprState = atom<any>({
  key: "pooolAprState",
  default: new Map(),
  dangerouslyAllowMutability: true,
});

export const poooluliqState = atom<any>({
  key: "poooluliqState",
  default: new Map(),
  dangerouslyAllowMutability: true,
});

export const pooolubondState= atom<any>({
  key: "pooolubondState",
  default: new Map(),
  dangerouslyAllowMutability: true,
});

